export const updateSidebarTotals = () => {
    // Calculate Current Commission Totals
    const newProjectsAmount = Number($('.js-new-projects-amount').val()) || 0;
    const projectsUnderAmount = Number($('.js-projects-under-amount').val()) || 0;
    const projectsOverAmount = Number($('.js-projects-over-amount').val()) || 0;
    const manualAmount = Number($('.js-manual-amount').val()) || 0;
    const adjustPreviousAmount = Number($('.js-adjust-previous-amount').val()) || 0;
    const newMaintenanceAmount = Number($('.js-new-maint-amount').val()) || 0;
    const fixedPriceAmount = Number($('.js-fixed-price-amount').val()) || 0;
    const commissionsTotal = newProjectsAmount + projectsUnderAmount + projectsOverAmount + manualAmount + adjustPreviousAmount + newMaintenanceAmount + fixedPriceAmount;

    $('.js-commission-total').val(commissionsTotal);
    $('.js-commission-total-text').text(kendo.format('{0:C2}', commissionsTotal));

    // Calculate Completed Current Commission Totals
    const prevGpAmount = Number($('.js-previous-gp-amount').val()) || 0;
    const janAmount = Number($('.js-jan-amount').val()) || 0;
    const febAmount = Number($('.js-feb-amount').val()) || 0;
    const marAmount = Number($('.js-mar-amount').val()) || 0;
    const aprAmount = Number($('.js-apr-amount').val()) || 0;
    const mayAmount = Number($('.js-may-amount').val()) || 0;
    const junAmount = Number($('.js-jun-amount').val()) || 0;
    const julAmount = Number($('.js-jul-amount').val()) || 0;
    const augAmount = Number($('.js-aug-amount').val()) || 0;
    const sepAmount = Number($('.js-sep-amount').val()) || 0;
    const octAmount = Number($('.js-oct-amount').val()) || 0;
    const novAmount = Number($('.js-nov-amount').val()) || 0;
    const decAmount = Number($('.js-dec-amount').val()) || 0;
    const ytdTotal = prevGpAmount + janAmount + febAmount + marAmount + aprAmount + mayAmount + junAmount + julAmount + augAmount + sepAmount + octAmount + novAmount + decAmount;

    $('.js-ytd-total').val(ytdTotal);
    $('.js-ytd-total-text').text(kendo.format('{0:C2}', ytdTotal));
}